<template>
    <Breadcrumb :items="breadcrumbs" />
    <div class="absence-page container-fluid my-3">
        <div class="filter my-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <h4>شيت الدفع {{ grade?.name ?? '' }} ({{ paggination }})</h4>
            </div>
            <div class="row">
                <div class="col-lg-8 col-md-12 col-12">
                    <div class="form-group">
                        <label for="search">ابحث</label>
                        <input type="search" id="search" class="form-control" placeholder="ابحث" v-model="word"
                            @keyup="fetchReservation">
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-12">
                    <div class="form-group d-flex flex-column">
                        <label for="gender">الجنس</label>
                        <Dropdown v-model="gender" :options="gender_list" optionLabel="title"
                            placeholder="الجنس" @change="fetchReservation" />
                    </div>
                </div>
                <div class="col-lg-2 col-md-3 col-12">
                    <div class="d-flex">
                        <div class="form-group d-flex flex-column mx-1">
                            <label for="" class="non_opacity">طباعة</label>
                            <button class="btn btn-success px-3" @click="exportToExcel">
                                <i class="pi pi-file-excel"></i>
                            </button>
                        </div>
                        <div class="form-group d-flex flex-column mx-1">
                            <label for="" class="non_opacity">طباعة</label>
                            <button class="btn btn-danger px-3" v-print="'#reservationTable'">
                                <i class="pi pi-file-pdf"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div id="reservationTable" class="a4">
            <div class="first-screen-pdf">
              <h1>شيت دفع</h1>
              <h2>{{ grade?.name ?? '' }}</h2>
              <h3>{{ gender?.id === 1 ? "بنين" : gender?.id === 2 ? "بنات" : "" }} ( {{ paggination }} )</h3>
            </div>
            <table class="table table-striped table-confirm">
                <thead>
                    <tr>
                        <th scope="col" rowspan="2">رقم</th>
                        <th scope="col" rowspan="2">
                            الاسم
                        </th>
                        <th scope="col" rowspan="2" colspan="3">الغياب</th>
                        <th scope="col" rowspan="2">رقم ولي الامر</th>
                        <th scope="col" colspan="11">الشهور</th>

                    </tr>
                    <tr>
                        <th class="month">8</th>
                        <th class="month">9</th>
                        <th class="month">10</th>
                        <th class="month">11</th>
                        <th class="month">12</th>
                        <th class="month">1</th>
                        <th class="month">2</th>
                        <th class="month">3</th>
                        <th class="month">4</th>
                        <th class="month">5</th>
                        <th class="month">6</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(reservation, index) in reservations.data" :key="index">
                        <td data-label="ID">{{ index + 1 }}</td>
                        <td data-label="الاسم">{{ reservation.name }}</td>
                        <td class="absence-cell"></td>
                        <td class="absence-cell"></td>
                        <td class="absence-cell"></td>
                        <td data-label="رقم ولي الامر">{{ reservation.parent_phone }}</td>
                        <td data-label="8">

                        </td>
                        <td data-label="9">

                        </td>
                        <td data-label="10">

                        </td>
                        <td data-label="11">
                        </td>
                        <td data-label="12">
                        </td>
                        <td data-label="1">
                        </td>
                        <td data-label="2">
                        </td>
                        <td data-label="3">
                        </td>
                        <td data-label="4">
                        </td>
                        <td data-label="5">
                        </td>
                        <td data-label="6">
                        </td>
                    </tr>
                    <!-- Add empty rows if needed -->
                    <tr v-for="n in extraRows" :key="'empty-' + n" class="empty-row">
                      <td>{{ reservations.data.length + n }}</td>
                      <td data-label="الاسم"></td>
                      <td class="absence-cell"></td>
                      <td class="absence-cell"></td>
                      <td class="absence-cell"></td>
                      <td data-label="رقم ولي الامر"></td>
                      <td data-label="8">

                      </td>
                      <td data-label="9">

                      </td>
                      <td data-label="10">

                      </td>
                      <td data-label="11">
                      </td>
                      <td data-label="12">
                      </td>
                      <td data-label="1">
                      </td>
                      <td data-label="2">
                      </td>
                      <td data-label="3">
                      </td>
                      <td data-label="4">
                      </td>
                      <td data-label="5">
                      </td>
                      <td data-label="6">
                      </td>
                    </tr>
                </tbody>
            </table>
          </div>
        </div>
        <div class="row">
            <div class="col-md-10 col-12">
                <pagination :data="reservations"
                    class="mx-auto d-flex align-items-center justify-content-center pagination"
                    @pagination-change-page="fetchReservation">
                    <template v-slot:prev-nav>&lt;</template>
                    <template v-slot:next-nav>&gt;</template>
                </pagination>
            </div>
            <div class="col-md-2 col-12 mt-md-0 mt-3">
                <div class="form-group d-flex md-justify-content-end justify-content-center">
                    <Dropdown v-model="per_page" :options="per_pages" showClear optionLabel="title"
                        placeholder="عدد الطلاب" @change="fetchReservation" />
                </div>
            </div>
        </div>
    </div>
    <div class="absence-page-mobile">
        يجب فتح هذا الجدول من جهاز الكمبيوتر
    </div>
</template>

<script>
import axios from 'axios';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import pagination from "laravel-vue-pagination";
import * as XLSX from "xlsx/xlsx.mjs";
import Breadcrumb from '@/components/global/breadcrumb.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
    name: "reservation-page",
    data() {
        return {
            reservations: {
                data: [],
            },
            certificate_image: "",
            visible: false,
            word: "",
            status: null,
            degree: "",
            gender: {
                id: 1,
                title: "ولد",
            },
            per_pages: [
                {
                    title: "الكل",
                    id: 10000,
                },
                {
                    title: 10,
                    id: 10,
                },
                {
                    title: 25,
                    id: 25,
                },
                {
                    title: 50,
                    id: 50,
                },
                {
                    title: 100,
                    id: 100,
                },
            ],
            per_page: null,
            paggination: "",
            sortAsc: true,
            orderByName: true,
            gender_list: [
                {
                    id: 1,
                    title: "ولد",
                },
                {
                    id: 2,
                    title: "بنت",
                },
            ],
        }
    },
    components: {
        Button,
        Dropdown,
        pagination,
        Breadcrumb
    },
    computed: {
        gradeStore() { return useGradeStore(); },
        gradeSlug() {
            return this.$route.params.gradeSlug;
        },
        grade() {
            const slug = this.gradeSlug;
            if (!slug) return null;
            return this.gradeStore.activeGrades.find(g => g.slug === slug)
                || this.gradeStore.allGrades.find(g => g.slug === slug)
                || null;
        },
        gradeId() {
            return this.grade?.id ?? null;
        },
        breadcrumbs() {
            const gradeName = this.grade?.name ?? this.gradeSlug ?? '';
            const gradePath = this.grade
                ? `/grades/${this.grade.slug}/students`
                : '/';
            return [
                { name: 'الرئيسية', path: '/' },
                { name: gradeName, path: gradePath },
                { name: 'شيت الدفع', path: this.$route.fullPath },
            ];
        },
        extraRows() {
            return 27 - (Number(this.paggination) % 27);
        },
    },
    methods: {
        fetchReservation(page = 1) {
            const formData = new FormData();
            formData.append('status', 1);
            formData.append('order_by_name', 1);
            if (this.gradeId) {
                formData.append('academic_year_id', this.gradeId);
            }

            if (this.word) {
                formData.append('word', this.word);
            }
            if (this.gender) {
                formData.append('gender', this.gender.id);
            }

            axios.defaults.headers.common["per_page"] = this.per_page == null ? 10 : this.per_page.id;
            axios
                .post(`/all_reservations?page=${page}`, formData)
                .then((response) => {
                    this.reservations = response.data.data;
                    this.paggination = response.data.data.meta.total;
                })
                .catch((error) => {
                    this.reservations = {};
                });
        },

        getEducationLevelLabel(level) {
          const levels = {
            1: "الاول الاعدادي",
            2: "الثاني الاعدادي",
            3: "الثالث الاعدادي",
            4: "الاول الثانوي",
            5: "الثاني الثانوي",
            6: "الثالث الثانوي",
          };
          return levels[level] || `${level}`;
        },

        getEducationLevelPath(level) {
          if (level == 3) return '/reservation';
          if (level == 4) return '/one_secondary';
          if (level == 5) return '/two_secondary';
          if (level == 6) return '/three_secondary';
          return `/absence/${level}`;
        },

        exportToExcel() {
            this.loading = true;
            const table = document.getElementById("reservationTable").cloneNode(true);
            const ws = XLSX.utils.table_to_sheet(table);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, "reservations.xlsx");
        },
    },
    async mounted() {
        if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
        if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
        this.fetchReservation();
    },
}
</script>

<style scoped>
.table-striped-columns>:not(caption)>tr>:nth-child(2n), .table-striped>tbody>tr:nth-of-type(odd)>* {
  --bs-table-bg-type: unset !important;
}
@media print {
    .table>:not(caption)>*>* {
      border-width: 2px !important;
      border-color: #000 !important;
    }
    th:nth-child(4),
    td:nth-child(4),
    th:nth-child(6),
    td:nth-child(6 ),
    th:nth-child(8),
    td:nth-child(8),
    th:nth-child(9),
    td:nth-child(9),
    th:nth-child(10),
    td:nth-child(10),
    th:nth-child(11),
    td:nth-child(11),
    th:nth-child(12),
    td:nth-child(12){
        display: table-cell !important;
    }
    table * {
        font-size: 0.8rem !important;
        font-weight: 900;
    }
    button i {
        display: none !important;
    }
    table thead tr th.month {
        width: 30px !important;
    }
    table tbody tr td.absence-cell {
        width: 30px;
    }
}

.empty-row {
  display: none;
}
@media print {
  .empty-row {
    display: table-row !important;
  }
}
</style>